import type { SvgIconComponent } from '@mui/icons-material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Chip } from '@mui/material';
import type { OrderStatus } from '../enum/orderStatus';
import { formatDueDate, isDueDateApproaching } from '../utils/order';

interface OrderDueDateChipProps {
  dueDate?: string | null;
  status: OrderStatus;
}

const OrderDueDateChip = ({ dueDate, status }: OrderDueDateChipProps) => {
  const approaching = Boolean(dueDate && isDueDateApproaching(dueDate, status));
  const tone = approaching ? 'red' : 'grey';

  let Icon: SvgIconComponent;
  let label: string;
  if (!dueDate) {
    Icon = EventBusyIcon;
    label = 'No due date';
  } else {
    Icon = approaching ? WarningAmberIcon : CalendarTodayIcon;
    label = formatDueDate(dueDate, status);
  }

  return (
    <Chip
      size="small"
      label={
        <Box
          component="span"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <Icon fontSize="small" />
          {label}
        </Box>
      }
      sx={{
        fontWeight: 600,
        color: `${tone}.900`,
        bgcolor: `${tone}.100`,
        border: '1px solid',
        borderColor: `${tone}.900`,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
};

export default OrderDueDateChip;
